/**
 *
 * Asynchronously loads the component for CatalogDetailShow
 *
 */

import React from 'react';

import { LoadingContainer } from 'app/components/LoadingContainer';
import { lazyLoad } from 'utils/loadable';

export const CatalogDetailShow = lazyLoad(
  () => import('./index'),
  module => module.CatalogDetailShow,
  { fallback: <LoadingContainer loading /> },
);
